/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const MicrophoneOff: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 25 24" fill="none">
    <path
      d="M3.25 3.20114L21.25 21.2011M9.25 5.20114C9.25 4.40549 9.56607 3.64243 10.1287 3.07982C10.6913 2.51721 11.4544 2.20114 12.25 2.20114C13.0456 2.20114 13.8087 2.51721 14.3713 3.07982C14.9339 3.64243 15.25 4.40549 15.25 5.20114V10.2011C15.25 10.4973 15.2062 10.7918 15.12 11.0751M13.12 13.0751C12.6717 13.211 12.1978 13.24 11.7362 13.1597C11.2747 13.0795 10.8384 12.8923 10.4622 12.6131C10.086 12.334 9.78041 11.9706 9.56992 11.5521C9.35942 11.1336 9.24986 10.6716 9.25 10.2031V9.20314M5.25 10.2011C5.24978 11.4645 5.59146 12.7043 6.23881 13.7892C6.88616 14.8741 7.81505 15.7636 8.92697 16.3633C10.0389 16.9631 11.2924 17.2507 12.5545 17.1957C13.8167 17.1408 15.0404 16.7453 16.096 16.0511M18.096 14.0511C18.8498 12.9088 19.2505 11.5698 19.248 10.2011M8.25 21.2011H16.25M12.25 17.2011V21.2011"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
}
